import { OrderLayout } from "@features/layout/order";

export const OrderPage = () => {
  return <OrderLayout />;
};
